(function () {
  var gate = document.getElementById('accessGate');
  if (!gate) return;

  var STORAGE_PREFIX = 'up_access_';
  var MAX_ATTEMPTS = 5;
  var LOCKOUT_MS = 5 * 60 * 1000;
  var ACCESS_TTL_MS = 24 * 60 * 60 * 1000;

  var expectedHash = gate.dataset.hash;
  var collectionHandle = gate.dataset.collection;
  var storageKey = STORAGE_PREFIX + collectionHandle;
  var lockoutKey = STORAGE_PREFIX + collectionHandle + '_lockout';

  var form = document.getElementById('accessGateForm');
  var input = document.getElementById('accessGateInput');
  var errorEl = document.getElementById('accessGateError');
  var attemptsEl = document.getElementById('accessGateAttempts');
  var submitBtn = document.getElementById('accessGateSubmit');
  var toggleBtn = document.getElementById('accessGateToggle');

  function getStoredAccess() {
    try {
      var raw = localStorage.getItem(storageKey);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (Date.now() - data.ts > ACCESS_TTL_MS) {
        localStorage.removeItem(storageKey);
        return null;
      }
      return data;
    } catch (_) {
      localStorage.removeItem(storageKey);
      return null;
    }
  }

  function getLockout() {
    try {
      var raw = localStorage.getItem(lockoutKey);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (Date.now() - data.ts > LOCKOUT_MS) {
        localStorage.removeItem(lockoutKey);
        return null;
      }
      return data;
    } catch (_) {
      localStorage.removeItem(lockoutKey);
      return null;
    }
  }

  function setLockout(attempts) {
    localStorage.setItem(lockoutKey, JSON.stringify({ attempts: attempts, ts: Date.now() }));
  }

  function grantAccess() {
    localStorage.setItem(storageKey, JSON.stringify({ ts: Date.now() }));
    localStorage.removeItem(lockoutKey);
    gate.classList.add('access-gate--unlocked');
    document.querySelectorAll('[data-gated-content]').forEach(function (el) {
      el.style.display = '';
    });
  }

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.style.display = 'block';
    input.classList.add('access-gate__input--error');
  }

  function clearError() {
    errorEl.textContent = '';
    errorEl.style.display = 'none';
    input.classList.remove('access-gate__input--error');
  }

  function updateAttemptsDisplay(remaining) {
    if (remaining <= 2 && remaining > 0) {
      attemptsEl.textContent = remaining + ' tentative' + (remaining > 1 ? 's' : '') + ' restante' + (remaining > 1 ? 's' : '');
      attemptsEl.style.display = 'block';
    } else {
      attemptsEl.style.display = 'none';
    }
  }

  function disableForm(seconds) {
    submitBtn.disabled = true;
    input.disabled = true;
    var interval = setInterval(function () {
      seconds--;
      if (seconds <= 0) {
        clearInterval(interval);
        submitBtn.disabled = false;
        input.disabled = false;
        submitBtn.textContent = 'Accéder à la collection';
        localStorage.removeItem(lockoutKey);
        clearError();
        updateAttemptsDisplay(MAX_ATTEMPTS);
      } else {
        var min = Math.floor(seconds / 60);
        var sec = seconds % 60;
        submitBtn.textContent = 'Réessayer dans ' + min + ':' + (sec < 10 ? '0' : '') + sec;
      }
    }, 1000);
  }

  async function hashCode(code) {
    var encoder = new TextEncoder();
    var data = encoder.encode(code);
    var buffer = await crypto.subtle.digest('SHA-256', data);
    var array = Array.from(new Uint8Array(buffer));
    return array.map(function (b) { return b.toString(16).padStart(2, '0'); }).join('');
  }

  var stored = getStoredAccess();
  if (stored) {
    grantAccess();
    return;
  }

  document.querySelectorAll('[data-gated-content]').forEach(function (el) {
    el.style.display = 'none';
  });

  var lockout = getLockout();
  if (lockout && lockout.attempts >= MAX_ATTEMPTS) {
    var elapsed = Date.now() - lockout.ts;
    var remainingSec = Math.ceil((LOCKOUT_MS - elapsed) / 1000);
    showError('Trop de tentatives. Veuillez patienter.');
    disableForm(remainingSec);
  }

  toggleBtn.addEventListener('click', function () {
    var isPassword = input.type === 'password';
    input.type = isPassword ? 'text' : 'password';
    toggleBtn.setAttribute('aria-label', isPassword ? 'Masquer le code' : 'Afficher le code');
    var icon = toggleBtn.querySelector('[data-lucide]');
    if (icon) {
      icon.setAttribute('data-lucide', isPassword ? 'eye-off' : 'eye');
      if (typeof lucide !== 'undefined') lucide.createIcons({ nodes: [icon] });
    }
  });

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    clearError();

    var currentLockout = getLockout();
    if (currentLockout && currentLockout.attempts >= MAX_ATTEMPTS) {
      showError('Trop de tentatives. Veuillez patienter.');
      return;
    }

    var code = input.value.trim();
    if (!code) {
      showError('Veuillez saisir un code d\'accès.');
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Vérification...';

    await new Promise(function (r) { setTimeout(r, 300 + Math.random() * 200); });

    var inputHash = await hashCode(code);

    if (inputHash === expectedHash) {
      grantAccess();
    } else {
      var attempts = currentLockout ? currentLockout.attempts + 1 : 1;
      setLockout(attempts);

      if (attempts >= MAX_ATTEMPTS) {
        showError('Trop de tentatives. Veuillez patienter 5 minutes.');
        disableForm(Math.ceil(LOCKOUT_MS / 1000));
        return;
      }

      showError('Code incorrect.');
      updateAttemptsDisplay(MAX_ATTEMPTS - attempts);
      input.value = '';
      input.focus();
      submitBtn.disabled = false;
      submitBtn.textContent = 'Accéder à la collection';
    }
  });
})();